// extracted by mini-css-extract-plugin
export default {"sticky":"footnotes_sticky__PJMlx"};